import { InviteTokenSchema } from '@ccex/shared';

/** The bot's "Open wallet" button appends `?invite=<token>` (spec 2026-10-22 §7); anything else is ignored. */
export function readInviteToken(search: string): string | null {
  const raw = new URLSearchParams(search).get('invite');
  const parsed = InviteTokenSchema.safeParse(raw);
  return parsed.success ? parsed.data : null;
}
